export enum TypeOfDocument {
  CLASSER = 'classer',
  NON_CLASSER = 'non-classer',
}

export enum TypeOfSurveyStatus {
  COMPLETED = 'completed',
  NOT_COMPLETED = 'inProgress',
  EXPIRE = 'expired',
  READY = 'ready',
  DRAFT = 'draft',
}

export enum AnalysisSource {
  data = 'data',
}

export enum AnalysisState {
  started = 'started',
  available = 'available',
  closed = 'closed',
}

export interface MedicalAnalysis {
  documentId: string
  revision: string
  documentVersion: number
  source: AnalysisSource
  createdAt: Date
  updatedAt: Date
  status: number | null
  closedBy: string | null
  state: AnalysisState
  rawAnalysis: Record<string, any> | null
}

export enum AnalysisSource {
  data = 'data',
}

export enum AnalysisState {
  started = 'started',
  available = 'available',
  closed = 'closed',
}

export interface MedicalAnalysis {
  documentId: string
  revision: string
  documentVersion: number
  source: AnalysisSource
  createdAt: Date
  updatedAt: Date
  status: number | null
  closedBy: string | null
  state: AnalysisState
  rawAnalysis: Record<string, any> | null
}
